// Shared formatters + period helpers for the client portal tabs.

export function formatCurrency(v, currency = 'AUD') {
  if (v == null || v === '') return '—'
  const n = Number(v)
  if (!Number.isFinite(n)) return '—'
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(n)
}

export function formatInt(v) {
  if (v == null || v === '') return '—'
  const n = Number(v)
  if (!Number.isFinite(n)) return '—'
  return new Intl.NumberFormat('en-AU').format(Math.round(n))
}

export function formatDate(s) {
  if (!s) return '—'
  try {
    return new Date(s).toLocaleDateString('en-AU', {
      year: 'numeric', month: 'short', day: 'numeric',
    })
  } catch {
    return String(s)
  }
}

export function currentMonthStart() {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`
}

export function todayStr() {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

// Tiny date-range header bar used by several tabs.
// Controlled component; the parent owns the state.
export function DateRangeFilter({ from, to, onChange }) {
  return (
    <div className="flex items-center gap-2 text-xs">
      <label className="text-slate-500">From</label>
      <input
        type="date"
        value={from || ''}
        onChange={e => onChange({ from: e.target.value, to })}
        className="border border-slate-200 rounded-md px-2 py-1 text-slate-600 focus:outline-none focus:ring-1 focus:ring-blue-400"
      />
      <label className="text-slate-500">to</label>
      <input
        type="date"
        value={to || ''}
        onChange={e => onChange({ from, to: e.target.value })}
        className="border border-slate-200 rounded-md px-2 py-1 text-slate-600 focus:outline-none focus:ring-1 focus:ring-blue-400"
      />
    </div>
  )
}
